<div class="ds-grid ds-grid--3">
	<!-- Primary Checkbox -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Primary Checkbox</h3>
			<p class="ds-example__header-subtitle">With no icon support</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				[label]="'Accept terms'"
				[checkedValue]="'Accepted'"
				[uncheckedValue]="'Not accepted'"
				(checkedChange)="onCheckboxChange('Primary', $event)">
			</eif-custom-checkbox>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ primaryValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Success Checkbox -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Success Checkbox</h3>
			<p class="ds-example__header-subtitle">With icon support</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				[label]="'Confirm action'"
				[color]="'success'"
				[icon]="'fa-solid fa-check'"
				[checkedValue]="'Confirmed'"
				[uncheckedValue]="'Pending'"
				(checkedChange)="onCheckboxChange('Success', $event)">
			</eif-custom-checkbox>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--success">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ successValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Info Checkbox with Icon -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Info Checkbox</h3>
			<p class="ds-example__header-subtitle">With icon and tooltip</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				[label]="'Enable notifications'"
				[color]="'info'"
				[icon]="'fa-solid fa-info-circle'"
				[tooltip]="'Receive email notifications'"
				[checkedValue]="'Enabled'"
				[uncheckedValue]="'Disabled'"
				(checkedChange)="onCheckboxChange('Info', $event)">
			</eif-custom-checkbox>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--info">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ infoValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Warning Checkbox -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Warning Checkbox</h3>
			<p class="ds-example__header-subtitle">With icon support</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				[label]="'Proceed with caution'"
				[color]="'warning'"
				[icon]="'fa-solid fa-exclamation-triangle'"
				[checkedValue]="'Proceed'"
				[uncheckedValue]="'Cancel'"
				(checkedChange)="onCheckboxChange('Warning', $event)">
			</eif-custom-checkbox>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--warning">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ warningValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Danger Checkbox -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Danger Checkbox</h3>
			<p class="ds-example__header-subtitle">With icon support</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				[label]="'Delete permanently'"
				[color]="'danger'"
				[icon]="'fa-solid fa-trash'"
				[checkedValue]="'Delete'"
				[uncheckedValue]="'Keep'"
				(checkedChange)="onCheckboxChange('Danger', $event)">
			</eif-custom-checkbox>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--danger">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ dangerValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Disabled Checkbox -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Disabled Checkbox</h3>
			<p class="ds-example__header-subtitle">Non-interactive state</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				[label]="'Cannot be changed'"
				[color]="'neutral'"
				[icon]="'fa-solid fa-ban'"
				[checkedValue]="'Active'"
				[disabled]="true"
				(checkedChange)="onCheckboxChange('Disabled', $event)">
			</eif-custom-checkbox>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ disabledValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Required Checkbox (validation on button) -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Required Checkbox</h3>
			<p class="ds-example__header-subtitle">Validation on button click</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-checkbox
				#validationCheckbox
				[label]="'Accept terms to continue'"
				[checkedValue]="'Accepted'"
				[uncheckedValue]="'Not accepted'"
				[validationRules]="requiredCheckboxRules"
				(validationChange)="onValidationChange($event)">
			</eif-custom-checkbox>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="validationCheckbox.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ validationValid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>
</div>
